<template>
  <div class="protocol1-container">
    <h4 class="title">
      <van-nav-bar title="星火服务贷款服务授权协议" left-text="返回" left-arrow @click-left="back" />
    </h4>
    <div class="content">
      <p>【阅读提示】</p>
      <p>很感谢您关注本贷款产品！本协议由星火（南通）信息服务有限公司（以下简称“贷款人”）及其关联公司、合作方与您签署，包含了对您个人信息进行收集、存储、保护、使用和共享的条款，建议您完整、审慎地阅读本协议，充分理解各条款内容，以帮助您了解维护自己隐私权的方式。为了使您充分理解本协议，本协议中与您的权益存在或可能存在重大关系的条款，本协议已采用粗体字进行标注。我们收集、存储、使用和共享您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的（包括支持我们开发新产品或完善已有产品功能，为您和其他用户提供更为优质的服务）。您向我们提供了本协议中列明的信息授权后，我们将努力保障您的信息安全。</p>
      <p>您访问公司网站或移动设备客户端进行注册/登陆，或通过页面点击确认/同意，或申请产品服务，或使用产品或接受产品服务，即视为您与贷款人及其关联公司、与贷款人及其关联公司合作的第三方（以上三类主体,以下统称“贷款产品服务方”）均已达成协议并同意接受本授权协议的所有条款，对本授权协议已充分理解，并知晓授权内容所产生的相关法律后果，如果您不同意本协议中的条款，请停止操作。</p>
      <h5>一、个人信息的授权</h5>
      <p>当您申请贷款时，您会向“贷款产品服务方”主动提供个人信息，“贷款产品服务方”也会收集/使用/共享您的个人信息，“贷款产品服务方”也可能会从商业合作伙伴获得信息以补充“贷款产品服务方”自己收集的信息，以向您提供更好的服务。</p>
      <p>个人信息是指：以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人基本信息、身份信息、账号信息、财产信息、教育信息、职业信息、联系信息、商户信息、位置信息、设备信息、风险测评信息等。</p>
      <p>（一）您同意并授权“贷款产品服务方”在以下情形获取/存储/使用/共享您的个人信息：</p>
      <p>1、为了确认和评估您的资信状况，您授权“贷款产品服务方”获取/存储/使用/共享您的个人信息；</p>
      <p>2、为便于您查询交易状态或历史记录，“贷款产品服务方”会保存您使用贷款服务产生的个人信息，并严格按照法律法规的规定对这些信息进行妥善保管，在核实您的身份后可向您提供查询服务；</p>
      <p>3、为了充分保护您的账户安全，当您申请贷款服务时， “贷款产品服务方”可能会记录您操作的相关信息；</p>
      <p>4、为了确保借款人身份的真实性和信息填写的准确性，您授权“贷款产品服务方”获取/存储/使用/共享您在“贷款产品服务方”处所填写、留存的个人信息。这些信息可帮助“贷款产品服务方”更好地识别您的身份以及保护您的账户安全（例如：您的账户在可疑操作环境下登录的，系统可能监控到您的账户风险，采取一些措施避免您的资金损失）；</p>
      <p>5、为充分保证贷款审查结果的准确性，避免因盲目借贷产生的社会不良后果，您授权“贷款产品服务方”根据服务需要，向行政机关、事业单位、司法机关、监管部门、中国互联网金融协会等行业自律组织、人力资源和社会保障部门、公积金管理中心、电信运营商、银行、非银行金融机构查询、获取、打印、留存您的个人信息；</p>
      <p>6、为了及时、高效地向您送达通知，您授权“贷款产品服务方”通过失联修复手段向依法留存您信息的第三方机构获取您的联系方式；</p>
      <p>7、为保障贷款人能及时与您取得联系，避免您因逾期还款而产生罚息、滞纳金等违约成本，您授权“贷款产品服务方”向第三方机构提供您的个人信息，以便及时向您告知贷款欠费情况；</p>
      <p>8、在发生借贷纠纷时，您授权并同意“贷款产品服务方”将基于本协议获悉的您的个人信息及还款信息提供给合法的第三方催收公司、律师事务所、法院、仲裁机构和其他合法机构，用于进行借款催收或解决纠纷；</p>
      <p>9、为保障贷款人的资金安全和债权，您授权“贷款产品服务方”基于对您债务偿还能力进行评估的目的，或者当您出现逾期还款时，获取您的个人信息；</p>
      <p>10、在您逾期还款或“贷款产品服务方”无法与您取得联系时，您授权并同意“贷款产品服务方”将贷款信息提供给您的联系人，并由前述人员转达还款主张。您确认上述转达为申请借款时的自愿行为，如您提供的联系人信息涉及第三方信息的，应当事先取得充分、合法的授权；</p>
      <p>11、您授权并同意，“贷款产品服务方”可以依法对您的个人信息进行整理、加工，以便为您提供更好的服务，并改进服务质量；</p>
      <p>12、您授权并同意“贷款产品服务方”将您的个人信息进行数据分析，并根据数据分析为您提供产品推广服务，并可通过短信、邮件等方式向您推送，您有权退订相关信息（退订方式包括：短信/电话退订）；</p>
      <p>13、您授权并同意“贷款产品服务方”将基于本协议获悉的您的信息提供给第三方进行验证、分析，以便评估信贷风险；</p>
      <p>14、您授权并同意“贷款产品服务方”根据自身服务、产品、推广、协同等目的，对您的还款信息、信用评估资料进行共享并使用；</p>
      <p>15、您同意并不可撤销地授权“贷款产品服务方”在信贷业务过程中（从业务申请至业务终止），基于约定用途（包括但不限于贷款审核、贷后管理、异议查询），可以通过依法设立的征信机构（包括但不限于百行征信等征信机构）查询您的信用报告，并同意按照征信监管机构相关规定向依法设立的征信机构报送个人基础信息及信贷信息，且同意授权“贷款产品服务方”将您的逾期贷款信息通过“贷款产品服务方”自有或第三方平台进行公示公告、提供给第三方使用，您知悉并理解授权条款声明；</p>
      <p>16、为了便于与您联系，您同意并授权“贷款产品服务方”获取您的商户地址，用于填写您的贷款通讯地址。</p>
      <p>（二）授权期限及信息保存期限</p>
      <p>您在本协议中对“贷款产品服务方”的授权期限为：长期。</p>
      <p>（三）个人信息的概念及具体内容</p>
      <p>1、个人信息是指：以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人基本信息、身份信息、账号信息、财产信息、教育信息、职业信息、联系信息、商户信息、位置信息、设备信息、风险测评信息；</p>
      <p>2、基本信息：姓名、出生日期、性别、联系地址、电话号码、电子邮箱/邮件；</p>
      <p>3、身份信息:包括身份证信息（身份证照片）、活检照片/视频、公安验证信息；</p>
      <p>4、账号信息：包括APP/网络账户名称、账号及其密码；</p>
      <p>5、财产信息：包括银行卡信息、收入信息（收入来源/收入水平）、交易记录、销售数据、账单数据、信贷信息（合同号/产品编号/额度编号/贷款编号/还款日期/流水号/还款方式/本金金额/利息金额/分期手续费金额/罚息金额/还款期数/还款类型等）、征信信息；</p>
      <p>6、教育、职业信息：包括学历、学位、职业类型、单位信息；</p>
      <p>7、联系信息：包括亲属信息、家庭信息、联系人信息；</p>
      <p>8、商户信息：包括商户号、商户名称、商户电话、商户地址、执照号；</p>
      <p>9、位置信息：包括定位信息、行踪轨迹；</p>
      <p>10、设备信息：包括设备型号、操作系统、设备标识符、设备识别码、IP地址、设备指纹ID、LBS定位地址、设备操作系统、设备蓝牙标识、设备WIFI标识、手机IMEI、设备软件版本信息、所属运营商、设备硬件信息、网络使用习惯、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息；您的计算机、手机及其访问设备发送给我们的信息；其他为提供服务必须收集的基础信息。如您不同意我们记录前述信息，可能无法完成风控验证；</p>
      <p>11、风险测评信息：包括个人主要收入来源、家庭投资金额占家庭总资产的比例、尚未清偿的债务、可投资的资产数额、收入状况、家庭可收支年收入、金融产品投资经验、投资状态、投资目标、投资可承受的风险、纳税情况、职业信息、个人年龄、个人须抚养人数、个人学历、家庭就业状况等。（具体以您参加风险测评时提供的信息为准）；</p>
      <h5>二、个人信息的使用</h5>
      <p>(一)因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的，为了实现这一目的，“贷款产品服务方”会把您的信息用于下列用途：</p>
      <p>1、向您提供贷款服务，对您提供的个人信息进行交叉验证或大数据分析、进行贷款风险评估、个人征信数据分析。</p>
      <p>2、比较信息的准确性，并与第三方进行验证，防止身份冒用。例如，将您向“贷款产品服务方”提交的身份信息与身份验证的服务机构进行验证。</p>
      <p>3、为使您知晓自己的贷款情况，向您发送还款提示、逾期还款通知。</p>
      <p>4、为您提供营销服务，进行营销活动及其他商业性电子信息的通知。如您拒绝营销服务，可通过短信退订指示或通过电话联系客服（客服电话详见星火南通信息服务APP的《隐私政策》）的方式进行退订。</p>
      <p>5、在您逾期还款时，自行或委托第三方合法机构进行文明合法的催收。</p>
      <p>6、在双方产生纠纷时向人民法院/仲裁机构申请诉讼/仲裁，进行财产保全，生效判决执行等工作。</p>
      <p>7、“贷款产品服务方”之间将逐渐允许用户登录各“贷款产品服务方”平台并使用其服务，“贷款产品服务方”用户的任何行为均需遵守该等平台服务协议的约定、平台公布的规则以及有关正确使用平台服务的说明和操作指引。为了实现上述功能，您同意“贷款产品服务方”的任一方将您在各“贷款产品服务方”的注册信息、交易/支付等信息和其他数据同步至其他“贷款产品服务方”系统并允许其基于本服务或您授权的其他情形而使用这些信息。</p>
      <p>8、您理解并同意，如您向“贷款产品服务方”提交、绑定或授权您的银行卡信息／账户，“贷款产品服务方”将可能:（1） 查询并核对您的账户/交易信息；2） 通过您所授权/绑定/“贷款产品服务方”知悉的您本人的银行卡进行代收、代付服务。</p>
      <p>9、预防或禁止非法的活动。</p>
      <p>10、经您许可的其他用途。</p>
      <p>（二）您完全理解并不可撤销地、免费地授予贷款人及其信息共享合作伙伴下列权利：</p>
      <p>1、本协议所称的信息共享合作伙伴指与贷款人共同加入中国互联网金融协会互联网金融信息共享平台的其他单位。</p>
      <p>2、您同意和授权贷款人收集并向中国互联网金融协会报送本人/本单位信用信息，并同意中国互联网金融协会获取、保存、分析处理该信用信息，报送的信用信息包括但不限于主体信息、借款信息、还款信息、逾期信息,以及以虚假主体或仿冒他人名义申请借款、提供虚假申请资料等欺诈信息（以下简称“信用信息”）。</p>
      <p>3、您同意并授权贷款人及其信息共享合作伙伴可在本人/本单位借款业务申请阶段及业务存续期间向中国互联网金融协会互联网金融信息共享平台查询本人/本单位的信用信息。</p>
      <p>4、您授权贷款人办理以下业务时，可以通过姓名或名称、证件类型、证件号码向中国互联网金融协会互联网金融信息共享平台查询本人/本单位信用信息：</p>
      <p>（1）审核本人/本单位借款申请业务；</p>
      <p>（2）审核本人/本单位作为担保人的业务；</p>
      <p>（3）对本人/本单位借款申请业务或者作为担保人的业务进行贷后风险管理；</p>
      <p>4）经中国互联网金融协会同意的其他情况。</p>
      <h5>三、Cookie的使用</h5>
      <p>为使您获得更轻松的访问体验，您申请贷款或享受贷款服务时，“贷款产品服务方”可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入部分信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</p>
      <p>请您理解，“贷款产品服务方”的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝Cookie，但这一举动在某些情况下可能会影响您安全访问贷款申请平台网站和使用贷款平台提供的服务。</p>
      <h5>四、保护和存储个人信息</h5>
      <p>为保障您的信息安全，“贷款产品服务方”努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。“贷款产品服务方”对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。</p>
      <p>“贷款产品服务方”会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，“贷款产品服务方”将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失。</p>
      <p>您的信息存储于中国的服务器上，为了安全及备份的需要，“贷款产品服务方”可能将您的信息和资料储存到“贷款产品服务方”或其他合作公司的服务器上。</p>
      <h5>五、共享个人信息</h5>
      <p>“贷款产品服务方”对您的信息承担保密义务，但“贷款产品服务方”会在下列情况下将您的信息与第三方共享：</p>
      <p>1、获得您的同意或授权。</p>
      <p>2、为了向您提供或推荐服务、产品，或为了向您提供更完善的服务，或者为了让您拥有更广泛的社交体验，“贷款产品服务方”会与包括合作商户在内的第三方共享您的相关信息。</p>
      <p>3、某些情况下，只有共享您的信息，才能提供您需要的服务和（或）产品，或处理您与他人的交易纠纷或争议。</p>
      <p>4、为了判断您的“贷款产品服务方”账户或交易是否安全。</p>
      <p>5、某些服务和（或）产品由“贷款产品服务方”的合作伙伴提供或由“贷款产品服务方”与合作伙伴、供应商共同提供，“贷款产品服务方”会与其共享提供服务和（或）产品需要的信息。</p>
      <p>6、根据法律规定及合理商业习惯，在“贷款产品服务方”计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下“贷款产品服务方”需要接受来自其他主体的尽职调查时，“贷款产品服务方”会把您的信息提供给必要的主体，但“贷款产品服务方”会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施。</p>
      <h5>六、对第三方责任的声明</h5>
      <p>请您注意，您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由“贷款产品服务方”处接受您的个人信息的第三方可能有自己的隐私权保护规则；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的Cookie或像素标签。同样，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受“贷款产品服务方”的控制，而且它们的使用不受本协议的约束。</p>
      <p>“贷款产品服务方”会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但“贷款产品服务方”无法保证这些主体一定会按照“贷款产品服务方”的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</p>
      <h5>七、特别注意事项及免责条款</h5>
      <p>1、“贷款产品服务方”仅向年满18周岁的人士提供服务，如果您未满18周岁，请您不要向“贷款产品服务方”提供任何个人信息，也不建议您使用任何“贷款产品服务方”提供的服务。</p>
      <p>2、根据相关法律、法规、部门规章及国家标准，在以下情形中，我们可能会依法收集并使用用户的个人信息无需征得用户的同意，包括：</p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>（4）出于维护您或他人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
      <p>（5）所收集的个人信息是您自行向社会公众公开的；</p>
      <p>（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</p>
      <p>（7）根据您的要求签订和履行合同所必需的；</p>
      <p>（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置服务的故障；</p>
      <p>（9）法律法规规定的其他情形。</p>
      <p>3、贷款人及其关联公司对收集的用户个人信息及行为将严格保密，并采取技术措施和其他必要措施，防止用户个人信息泄漏、丢失。贷款人及其关联公司不会对外公开或向第三方提供您的信息，但下列情况除外：</p>
      <p>（1）已事先获得您的授权或同意；</p>
      <p>（2）根据法律法规及相关有权机关的要求；</p>
      <p>（3）贷款人及其关联公司在与第三方合作向您提供相关服务且该第三方同意承担同等保护标准；</p>
      <p>（4）本协议约定的情况下；</p>
      <p>（5）贷款人及其关联公司对信息进行分析或调查研究，并对此行商业或非商业上的利用。</p>
      <h5>八、协议修订</h5>
      <p>“贷款产品服务方”可能随时会对本协议进行变更，由于“贷款产品服务方”的用户群过于庞大和分散，因此如发生变更，“贷款产品服务方”将选择在“贷款产品服务方”网站以公告的方式予以公布而不再另行单独通知您，该等变更将在公布时即时生效。若您在本协议变更后继续访问“贷款产品服务方”网站及其相关网站、“贷款产品服务方”移动设备客户端，或使用“贷款产品服务方”提供的任一服务，“贷款产品服务方”相信这代表您已充分阅读、理解并接受修改后的本协议并受之约束。</p>
      <h5>九、纠纷解决</h5>
      <p>因本协议所引起的您与“贷款产品服务方”的任何纠纷或争议，应友好协商，协商不成，您在此完全同意将纠纷或争议提交给本协议签订地法院管辖。本协议签订地为中国江苏省南通市崇川区。</p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.back()
    }
  }
}
</script>
<style lang="less">
.protocol1-container {
  background: #fff;
  padding: 0 10px 10px;

  .content {
    padding-top: 50px;
  }

  .title {
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    background: #fff;
    border-bottom: 1px solid #eee;

    .icon {
      line-height: 80px;
      position: absolute;
      left: 10px;
    }
  }

  p {
    font-size: 15px;
    text-indent: 2em;
    line-height: 22px;

    &.tip {
      font-weight: bold;
    }
  }

  h5 {
    font-size: 20px;
    text-indent: 1.5em;
    margin-top: 5;
  }
}
</style>
